import {FeOrder} from "../../redux/types";
import {Divider, makeStyles, Typography} from "@material-ui/core";
import React, {FC} from "react";
import {Skeleton} from "@material-ui/lab";
import {getFullName} from "../../../../utils";
import {format} from "date-fns";
import {FeClient} from "../../../clients/redux/types";
import {OrderStatusChip} from "../../sharedComponents/OrderStatusChip";

interface OrderHeadlineProps {
    order?: FeOrder;
    client?: FeClient;
}

const useStyles = makeStyles((theme) => ({
    orderHeadlineContainer: {
        position: 'relative',
        paddingBottom: theme.spacing(4)
    },
    staticCaption: {
        width: theme.spacing(7)
    }
}));

export const OrderHeadline: FC<OrderHeadlineProps> = ({order, client}) => {
    const classes = useStyles();

    return (
        <div className={classes.orderHeadlineContainer}>
            <Typography color="primary"
                        variant="h4"
            >
                Auftrag: {(client && order) ? getFullName(client, false) + " " + format(new Date(order.estimatedFrom), 'dd.MM.yyyy') :
                <Skeleton width={200}/>}</Typography>
            <div>
                <Typography variant={"caption"} color="textSecondary" style={{display: 'inline-flex'}}>
                    {!order
                        ? (<Skeleton width={160}/>)
                        : (<><Typography variant="inherit"
                                         className={classes.staticCaption}>seit:</Typography> {format(new Date(order.createdAt), 'dd.MM.yyyy - HH:mm')}</>)
                    }
                </Typography>
            </div>
            <div>
                <Typography variant={"caption"} color="textSecondary" style={{display: 'inline-flex'}}>
                    {!order
                        ? (<Skeleton width={160}/>)
                        : (<><Typography variant="inherit"
                                         className={classes.staticCaption}>geändert:</Typography>{format(new Date(order.updatedAt), 'dd.MM.yyyy - HH:mm')}</>)
                    }
                </Typography>
            </div>
            <div style={{position: 'absolute', right: 0, top: 24}}>
                {order && <OrderStatusChip order={order}/>}
            </div>
            <Divider style={{marginTop: 8}}/>
        </div>
    )
}

